// App.tsx - Updated with GTM initialization
import React from 'react';
import { observer } from 'mobx-react-lite';
import Header from './components/Header';
import StepperModel from './models/StepperModel';
import { STEP_SITE_BUILDER } from './steps/steps-definitions';
import SiteBuilderModel from './steps/SiteBuilder/model/SiteBuilderModel';
import Hero from './components/Hero';
import PageContainer from './components/PageContainer';
import StepRender from './components/StepRender';
import ResetWizard from './components/debug/ResetWizard';
import RequestTrackerService from './services/RequestTrackerService';
import LocalStorage from './services/LocalStorage';
import gtm from 'react-gtm-module';

function App() {

  React.useEffect(() => {
    window.addEventListener('beforeunload', (e) => {
      if (RequestTrackerService.isRequestInProgress()) {
        e.preventDefault();
        e.returnValue =
          'There are still requests in progress. Are you sure you want to leave?';

        LocalStorage.startExitingPageTransaction();

        setTimeout(() => {
          setTimeout(() => {
            // the user has decided to stay
            LocalStorage.finishExitingPageTransaction();
          }, 1000);
        }, 1);

        return;
      }
    });
  }, []);

  const isPreviewMode =
    StepperModel.currentStep === STEP_SITE_BUILDER &&
    SiteBuilderModel.iframeVisibility;


  return (
    <div
      className={`${isPreviewMode ? 'preview-editor-active ' : ''}${isPreviewMode ? '' : 'min-h-screen '}flex flex-col font-roboto-sans`}>
      <main className="flex-1 flex flex-col">
        <PageContainer>
          <Hero />
          <StepRender />
          <ResetWizard />
        </PageContainer>
      </main>
      <Header />
    </div>
  );
}

export default observer(App);